var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M17.43 8.80999C18.38 8.81999 19.7 8.81999 20.83 8.81999C21.4 8.81999 21.7 8.14999 21.3 7.74999C19.86 6.29999 17.28 3.68999 15.8 2.20999C15.39 1.79999 14.68 2.07999 14.68 2.64999V6.13999C14.68 7.59999 15.92 8.80999 17.43 8.80999Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M9.28619 15.6421C8.93178 15.6421 8.64336 15.3537 8.64336 14.9993C8.64336 14.6449 8.93178 14.3565 9.28619 14.3565C9.6406 14.3565 9.92902 14.6449 9.92902 14.9993C9.92902 15.3537 9.6406 15.6421 9.28619 15.6421ZM9.2849 13.4994C8.45779 13.4994 7.78496 14.1722 7.78496 14.9993C7.78496 15.8264 8.45779 16.4993 9.2849 16.4993C10.112 16.4993 10.7848 15.8264 10.7848 14.9993C10.7848 14.1722 10.112 13.4994 9.2849 13.4994ZM9.37904 17.141C7.53369 17.1838 6.32988 15.6055 5.93047 14.9974C6.37016 14.3095 7.47755 12.9013 9.1909 12.8576C11.029 12.8109 12.2396 14.3931 12.639 15.0012C12.1998 15.689 11.092 17.0973 9.37904 17.141ZM13.5144 14.7862C13.241 14.3096 11.7307 11.9209 9.16971 12.001C6.80067 12.061 5.42287 14.148 5.05689 14.7862C4.98104 14.9182 4.98104 15.0806 5.05689 15.2126C5.32645 15.6827 6.78353 17.999 9.29614 17.999C9.33128 17.999 9.36642 17.9986 9.40156 17.9977C11.7702 17.9373 13.1484 15.8507 13.5144 15.2126C13.5898 15.0806 13.5898 14.9182 13.5144 14.7862Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }